module.exports = __webpack_public_path__ + "assets/c87f10d2492fb2c17d0f7c3153b421ea.png";